import { render, staticRenderFns } from "./Payslip.vue?vue&type=template&id=3c49f6a0&"
import script from "./Payslip.vue?vue&type=script&lang=js&"
export * from "./Payslip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports